import React, { useEffect, useRef } from "react";

import { useFontsLoaded } from "@multiweb/reactUtils";
import { IComponentSize } from "@multiweb/types/react";
import { classNames } from "./constants";

interface IMeasurerItemProps {
    /** Měřená komponenta. */
    children: React.ReactNode;
    /** Callback volaný v momentě vyrenderování komponenty. */
    onMeasuredCallback: (size: IComponentSize) => void;
}

/**
 * Vyrenderuje komponentu a v callbacku vrátí její reálné rozměry v HTML.
 */
export const MeasuredItem: React.FC<IMeasurerItemProps> = ({
    children,
    onMeasuredCallback,
}) => {
    const fontLoaded = useFontsLoaded();
    const itemRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (fontLoaded && itemRef?.current) {
            const { width, height } = itemRef.current.getBoundingClientRect();
            onMeasuredCallback({ width, height });
        }
    }, [fontLoaded, onMeasuredCallback]);

    return (
        <div ref={itemRef} className={classNames("measured-item")}>
            {children}
        </div>
    );
};
